import groupBy from 'lodash-es/groupBy';
import forEach from 'lodash-es/forEach';
import orderBy from 'lodash-es/orderBy';

export const groupAndSortSummary = (summary, type = '') => {
    const mappedSummary = {};

    if (type.toLowerCase() === 'product') {
        const summaryGroup: object = groupBy(orderBy(summary, ['product', 'location', 'subLocation']), 'product');
        forEach(summaryGroup, (locations, locationName) => {
            const subLocationsGroup: object = groupBy(locations, 'location');
            mappedSummary[locationName] = subLocationsGroup;
        })
    } else if (type.toLowerCase() === 'site name') {
        const summaryGroup: object = groupBy(orderBy(summary, ['siteName', 'location', 'subLocation', 'product']),
            'siteName');
        forEach(summaryGroup, (sites, siteName) => {
            const subLocationsGroup: object = groupBy(sites, (subLocation) =>
                `${subLocation.location}, ${subLocation.subLocation}`);
            mappedSummary[siteName] = subLocationsGroup;
        })
    } else {
        const summaryGroup: object = groupBy(orderBy(summary, ['location', 'subLocation', 'product']), 'location');
        forEach(summaryGroup, (locations, locationName) => {
            const subLocationsGroup: object = groupBy(locations, 'subLocation');
            mappedSummary[locationName] = subLocationsGroup;
        })
    }

    return mappedSummary;
}
